import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'

@Injectable({ providedIn: 'root' })
export class ContratoCoordenadorService {
  private baseUrl = environment.baseUrl
  private resource = 'ContratoCoordenador'

  constructor(private httpClient: HttpClient) {}

  public getNecessidade(contratoId: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Contrato/${contratoId}/necessidade`,
    )
  }

  public definir(payload: {
    contratoId: string
    tipoTrechoId: number
    coordenadores: { coordenadorId: number; dataServico?: string | null; hora?: string | null; local?: string | null }[]
  }): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/definir`,
      payload,
    )
  }

  public getByContrato(contratoId: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Contrato/${contratoId}`,
    )
  }
}
